<template lang="html">
<div class="relative overflow-y-scroll bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner p-2 h-full">
  <!-- list of peers state -->
  <div v-if="connected_peers.length">
    <transition-group name="slide-in" class="grid gap-2" :class="peerColumns">
      <anywhere-participant :ref="'peer_' + peer.public_key" class="slide-in-item" :peer="peer"
                            v-on:speaking="onSpeaking(peer.public_key)"
                            :showActions="showActions"
                            v-for="peer in connected_peers" :key="peer.public_key" v-if="peer.showInUI">
      </anywhere-participant>
    </transition-group>
  </div>
  <!-- else show a Empty state -->
  <div class="absolute inset-0 text-gray-600 flex justify-center items-center h-full" v-else>
    <div class="text-center">
      Nobody is here yet
    </div>
  </div>
  <!-- end of empty state -->

  <!-- hidden participants, (Host inAnyhwere) -->
  <div class="hidden">
    <participant :ref="'peer_' + peer.public_key" class="slide-in-item" :peer="peer" :callingPeer="false"
                 :showActions="showActions"
                 v-on:speaking="onSpeaking(peer.public_key)"
                 v-for="peer in connected_peers" v-if="!peer.showInUI"
                 :key="peer.public_key"></participant>
  </div>
</div>
</template>

<script lang="js">
import AnywhereParticipant from './anywhere-participant.vue'
import { addNewPeer, updatePeer, removePeer, setupSpeaking, onSpeaking } from "common/participant"

export default {
  props: {
    isHost: false,
  },
  components: {
    AnywhereParticipant
  },
  data() {
    return {
      connected_peers: [],
      showActions: false,
      showIsSpeaking: false,
      speaking: {
        isSpeaking: false,
        name: "Nobody is speaking",
        role: "-"
      },
    }
  },
  computed: {
    peerColumns() {
      let columns = 'grid-cols-' + (this.connected_peers.length > 1 ? 2 : 1)
      if (product == 'anywhere' || role == 'host') columns = 'grid-cols-1'
      return columns
    }
  },
  mounted() {
    this.showIsSpeaking = false

    setupSpeaking( (data) => {
      this.speaking = data;
    });
  },
  methods: {
    addNewPeer(newPeer) {
      newPeer.showInUI = true
      if (window.role == "talent" && newPeer.role == "host"){
        newPeer.showInUI = false
      }
      this.connected_peers = addNewPeer(newPeer);
    },
    updatePeer(peerData){
      this.connected_peers = updatePeer(peerData)
    },
    removePeer(pk){
      this.connected_peers = removePeer(this.connected_peers, pk)
    },
    onSpeaking(public_key){
      onSpeaking(public_key, (data) => {
        this.speaking = data;
      });
    },
    getPeerConnectionComponent(public_key) {
      const ref = this.$refs['peer_' + public_key]
      if (ref == undefined) return;
      return this.$refs['peer_' + public_key][0]
    },
    getPeerConnection(public_key) {
      let peer = this.connected_peers.filter(peer => peer.public_key == public_key)[0]
      if (peer == null) return null;
      peer.component = this.getPeerConnectionComponent(public_key);
      return peer;
    },
  },
}
</script>